module.exports = __webpack_public_path__ + "static/media/herdy-cheering.bb9cba04.svg";